var map = {
	"./fortuneIcon.svg": 657,
	"./fortuneIconL.svg": 658,
	"./helpdeskIcon.svg": 659,
	"./helpdeskIconL.svg": 660,
	"./homeIcon.svg": 661,
	"./homeIconLarge.svg": 662,
	"./jackpotIcon.svg": 663,
	"./logo.svg": 664,
	"./logoSmall.svg": 665,
	"./loyaltyIcon.svg": 666,
	"./mobileAppIcon.svg": 667,
	"./profileIcon.svg": 668,
	"./questIcon.svg": 669,
	"./rewardLineupIcon.svg": 670,
	"./searchIcon.svg": 671,
	"./searchIconLarge.svg": 672,
	"./signOutIcon.svg": 673,
	"./star.svg": 674,
	"./tournamentIcon.svg": 675,
	"./tournamentLargeIcon.svg": 676,
	"./vipIcon.svg": 677,
	"./wheelIcon.svg": 678,
	"./wheelIconL.svg": 679,
	"./wheelIconMobile.svg": 680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 656;